/**
 * CRITICAL: Performance monitoring utilities
 * Use these to ensure charts render < 500ms
 */

export const measurePerformance = (name: string) => {
  const startMark = `${name}-start`;
  const endMark = `${name}-end`;
  const measureName = `${name}-duration`;

  performance.mark(startMark);

  return {
    end: () => {
      performance.mark(endMark);
      performance.measure(measureName, startMark, endMark);

      const measure = performance.getEntriesByName(measureName)[0];

      if (measure && measure.duration > 500) {
        console.warn(`⚠️ Slow operation: ${name} took ${measure.duration.toFixed(2)}ms`);
      }

      return measure?.duration || 0;
    }
  };
};

export const checkDataPointLimit = (data: any[]): boolean => {
  // Convert env variable to number (Vite returns strings)
  const limit = Number(import.meta.env.VITE_MAX_DATA_POINTS) || 5000;
  if (data.length > limit) {
    console.error(`❌ Too many data points: ${data.length} > ${limit}`);
    return false;
  }
  return true;
};